import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n' // Initialize react-i18next before the app renders
import { initObservability } from './lib/observability'

// Must run before React renders so console/network capture covers startup.
initObservability()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
